import request from 'api/request';

export default function accountEnrollmentIndexRoute() {
  return request({ url: '/account/enrollments' });
}
